import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { addPaymentMode, updatePaymentMode } from "network/service";

export default function AddPaymentMode(props) {
    const [newField, setNewField] = useState({ name: "" });
    const [errors, setErrors] = useState({});
    const { showNotification } = useNotification();
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let isValid = true;
        let newErrors = {};

        if (newField.name.trim() === "") {
            newErrors = { ...newErrors, name: "Name is required" };
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    };

    const submit = async () => {
        try {
            const isValid = validate();
            if (!isValid) return;

            setLoading(true);
            if (props.details && props.details._id) {
                await updatePaymentMode(props.details._id, { name: newField.name });
                showNotification("success", "Success", "Updated Payment Mode successfully");
            } else {
                await addPaymentMode({ name: newField.name });
                showNotification("success", "Success", "Added Payment Mode successfully");
            }
            props.handlesuccess();
            props.handleclose();
            setLoading(false);
        } catch (err) {
            console.error("Error saving payment mode:", err);
            setLoading(false);
            showNotification("error", "Error", "Failed to save Payment Mode.");
        }
    };

    useEffect(() => {
        if (props.details) {
            setNewField({ name: props.details.name || "" });
        } else {
            setNewField({ name: "" });
        }
    }, [props.details]);

    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >
            <div>
                <DialogTitle>{props.details ? "Edit Payment Mode" : "Add Payment Mode"}</DialogTitle>
            </div>
            <DialogContent sx={{ minWidth: 500 }}>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <MDInput
                            label="Name"
                            value={newField.name}
                            fullWidth
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    name: e.target.value
                                });
                            }}
                            helperText={<FormHelperText sx={{ color: "red", fontWeight: 800, margin: 0 }}>{errors.name}</FormHelperText>}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton variant="gradient" color="error" onClick={props.handleclose}>
                    <Icon>close</Icon>&nbsp;
                    Cancel
                </MDButton>
                <MDButton variant="gradient" color="success" onClick={submit} disabled={loading}>
                    <Icon>save</Icon>&nbsp;
                    Save
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}
